import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { putBlob } from 'redux/modules/api/blob'

function decorator() {
  return ComposedComponent => {
    @connect(({ auth }) => ({
      blob: auth.blob
    }), { putBlob })
    class Blob extends Component {
      static propTypes = {
        // blob: React.PropTypes.object.isRequired
        putBlob: PropTypes.func.isRequired,
      }

      handlePutBlob = files => this.props.putBlob(files)

      render() {
        return (
          <ComposedComponent {...this.props} onPutBlob={this.handlePutBlob} />
        )
      }
    }
    return Blob
  }
}


export default decorator
